var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9433_18468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15C1.34315 15 -5.87108e-08 13.6569 -1.31134e-07 12L-3.93402e-07 6C-4.65826e-07 4.34315 1.34315 3 3 3L17.1295 3C17.5154 3 17.7558 3.41861 17.5614 3.75194L14.647 8.74806C14.5561 8.90375 14.5561 9.09625 14.647 9.25194L17.5614 14.2481C17.7558 14.5814 17.5154 15 17.1295 15L3 15Z",
    fill: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6L8 9",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    transform: "rotate(-180 8 12)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9433_18468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantRed);
export default __webpack_public_path__ + "static/media/important_red.af3b37a6611bce7da33c19406655c8b1.svg";
export { ForwardRef as ReactComponent };